import { Auth } from "aws-amplify"

export const auth = {
  namespaced: true,
  state: {
    user: null,
    accessToken: null,
  },
  mutations: {
    setUser(state, payload) {
      state.user = payload
      console.log('user state changed to', state.user)
    },
    setAccessToken(state, payload) {
      state.accessToken = payload
    },
  },
  actions: {
    async getUser(context) {
      const userInfo = await Auth.currentUserInfo()
      if (userInfo) {
        context.commit('setUser', userInfo)
      }
    },
    async getAccessToken(context) {
      const currentSession = await Auth.currentSession()
      const accessToken = await currentSession.getAccessToken()
      const jwt = await accessToken.getJwtToken()
      context.commit('setAccessToken', jwt)
    }
  }
}



